module.exports = __webpack_public_path__ + "static/media/meritus-thumbnail.224accf7.jpg";